import { useState, useCallback } from 'react';

interface UseFilterDisplayProps {
  modalType?: string;
}

interface UseFilterDisplayReturn {
  filterDisplay: boolean;
  setFilterDisplay: React.Dispatch<React.SetStateAction<boolean>>;
  toggleFilter: () => void;
}

/**
 * Custom hook for managing filter panel visibility
 *
 * RESPONSIBILITIES:
 * - Filter display state
 * - Toggle handler
 *
 * Modal-aware initialization: hidden in modals, visible otherwise.
 *
 * EXTRACTED FROM: transactions.tsx (Phase 2 refactoring)
 */
export const useFilterDisplay = ({ modalType }: UseFilterDisplayProps): UseFilterDisplayReturn => {
  const [filterDisplay, setFilterDisplay] = useState<boolean>(!modalType);

  const toggleFilter = useCallback(() => {
    setFilterDisplay((prev) => !prev);
  }, []);

  return { filterDisplay, setFilterDisplay, toggleFilter };
};
